// extracted by mini-css-extract-plugin
export default {"loadingOverlay":"Loader_loadingOverlay__BJqaa","loadingSpinner":"Loader_loadingSpinner__zmV2F","spin":"Loader_spin__I0Tfd","loading-overlay":"Loader_loading-overlay__NnZbG"};